import { Action } from '@ngrx/store';

export enum CoreActionTypes {
    SetDateFormat = '[core] Set Date Format',
    SetRedirect = '[core] Set Redirect'
}

export class SetDateFormat implements Action {
    constructor(public payload: string) {}
    readonly type = CoreActionTypes.SetDateFormat;
}
export class SetRedirect implements Action {
    constructor(public payload: string | null) {}
    readonly type = CoreActionTypes.SetRedirect;
}
export type CoreActionsUnion = SetDateFormat | SetRedirect;
